const cookiesButton = document.querySelector('.cookies__close');
if (cookiesButton) {
    cookiesButton.addEventListener('click', e => {
        document.querySelector('.cookies').classList.remove('open');
    });
}